import request from './request.js'
// /project/getProject?projectid=867929034&agencyid=1
export function getWebBlock(data){
  return request({
    url: 'arcweb/getWebBlock',
    method: 'post',
    params: data
  });
}
//测试  提交

// Calendly Available Slot
export function getFreeSlots(data){
  return request({
    url: 'calendly/getFreeSlots',
    method: 'post',
    params: data
  });
}

// Calendly Book Demo
export function bookDemo(data){
  return request({
    url: 'calendly/bookDemo',
    method: 'post',
    params: data
  });
}
